import { loadPrefs, savePrefs, mergePrefs } from './marketplace-prefs.js';
/**
 * Rendert die geteilte App-Shell (Sidebar + Topbar + Panel). `marketplaces`
 * ist die Registry der App — jede Marktplatz-App uebergibt ihre Eintraege,
 * das Aussehen ist fuer alle identisch.
 */
export async function renderShell(ctx, marketplaces) {
    ctx.contentEl.hidden = false;
    // Status-Dot aus dem Page-Chrome ausblenden (wie im Dashboard).
    const dot = document.querySelector('#status-dot');
    if (dot)
        dot.style.display = 'none';
    const byId = new Map(marketplaces.map((m) => [m.id, m]));
    let activeId = marketplaces[0].id;
    // Praeferenzen laden und mit der Registry mergen. Bei Fehler liefert loadPrefs []
    // → mergePrefs faellt auf die Registry-Default-Reihenfolge zurueck.
    const prefs = await loadPrefs(ctx);
    let view = mergePrefs(marketplaces, prefs);
    ctx.contentEl.innerHTML = `
    <div class="kl-shell">
      <aside class="kl-sidebar">
        <div class="kl-sidebar-brand">
          <img class="kl-brand-logo" src="/logo-black.png" alt="go!e Commerce" width="835" height="338" />
          <span id="kl-sidebar-tenant" class="kl-sidebar-tenant">Lade Account …</span>
        </div>
        <div class="kl-sidebar-groups" id="kl-sidebar-nav"></div>
        <div class="kl-sidebar-foot">
          <div class="kl-sidebar-ava">··</div>
          <div class="kl-sidebar-foot-text">
            <b>Konto</b>
            <button type="button" class="kl-sidebar-logout" id="kl-logout">Abmelden</button>
          </div>
        </div>
      </aside>
      <main class="kl-shell-main">
        <div class="kl-shell-topbar">
          <div class="kl-shell-mp" id="kl-shell-mp"></div>
          <span class="kl-connected"><span class="v-icon fa-light fa-circle-check"></span> verbunden</span>
        </div>
        <div class="kl-shell-panel" id="kl-shell-panel"></div>
      </main>
    </div>
  `;
    const navEl = ctx.contentEl.querySelector('#kl-sidebar-nav');
    const panelEl = ctx.contentEl.querySelector('#kl-shell-panel');
    const mpEl = ctx.contentEl.querySelector('#kl-shell-mp');
    let dragId = null;
    function blockArr(id) {
        return view.favorites.includes(id) ? view.favorites : view.others;
    }
    function blockName(id) {
        return view.favorites.includes(id) ? 'fav' : 'all';
    }
    function itemHtml(m, block, favOn) {
        return `
      <div class="kl-sidebar-item ${m.id === activeId ? 'is-active' : ''}"
           data-mp="${m.id}" data-block="${block}" draggable="true">
        <button type="button" class="kl-sidebar-star ${favOn ? 'is-on' : ''}"
                data-star="${m.id}" aria-label="Favorit umschalten"
                title="${favOn ? 'Favorit entfernen' : 'Als Favorit'}">
          <span class="v-icon ${favOn ? 'fa-solid' : 'fa-light'} fa-star"></span>
        </button>
        <span class="kl-sidebar-tile">${m.tile}</span>
        <button type="button" class="kl-sidebar-open" data-open="${m.id}">
          <span class="kl-sidebar-item-label">${m.label}</span>
        </button>
        <span class="kl-sidebar-moves">
          <button type="button" class="kl-sidebar-move" data-move="up" data-mp="${m.id}" aria-label="Nach oben">
            <span class="v-icon fa-light fa-chevron-up"></span>
          </button>
          <button type="button" class="kl-sidebar-move" data-move="down" data-mp="${m.id}" aria-label="Nach unten">
            <span class="v-icon fa-light fa-chevron-down"></span>
          </button>
        </span>
      </div>
    `;
    }
    function renderNav() {
        const blocks = [];
        if (view.favorites.length) {
            blocks.push('<div class="kl-sidebar-section">Favoriten</div>');
            blocks.push(`<nav class="kl-sidebar-nav" data-block="fav">${view.favorites
                .map((id) => itemHtml(byId.get(id), 'fav', true))
                .join('')}</nav>`);
        }
        blocks.push(`<div class="kl-sidebar-section">${view.favorites.length ? 'Alle Marktplätze' : 'Marktplätze'}</div>`);
        blocks.push(`<nav class="kl-sidebar-nav" data-block="all">${view.others
            .map((id) => itemHtml(byId.get(id), 'all', false))
            .join('')}</nav>`);
        navEl.innerHTML = blocks.join('');
        wireNav();
    }
    function wireNav() {
        for (const b of navEl.querySelectorAll('.kl-sidebar-open')) {
            b.addEventListener('click', () => {
                const id = b.dataset.open;
                // Klick auf den bereits aktiven Marktplatz ist ein No-Op — sonst wuerde
                // der offene Tab im Panel durch den Re-Render zuruecksetzen.
                if (id === activeId)
                    return;
                void activate(id);
            });
        }
        for (const b of navEl.querySelectorAll('.kl-sidebar-star')) {
            b.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleFavorite(b.dataset.star);
            });
        }
        for (const b of navEl.querySelectorAll('.kl-sidebar-move')) {
            b.addEventListener('click', (e) => {
                e.stopPropagation();
                move(b.dataset.mp, b.dataset.move === 'up' ? -1 : 1);
            });
        }
        wireDnd();
    }
    function wireDnd() {
        for (const item of navEl.querySelectorAll('.kl-sidebar-item')) {
            item.addEventListener('dragstart', (e) => {
                dragId = item.dataset.mp ?? null;
                item.classList.add('is-dragging');
                if (e.dataTransfer && dragId) {
                    e.dataTransfer.setData('text/plain', dragId);
                    e.dataTransfer.effectAllowed = 'move';
                }
            });
            item.addEventListener('dragend', () => {
                dragId = null;
                for (const el of navEl.querySelectorAll('.is-dragging, .is-drop-target')) {
                    el.classList.remove('is-dragging', 'is-drop-target');
                }
            });
            item.addEventListener('dragover', (e) => {
                if (!dragId || dragId === item.dataset.mp)
                    return;
                if (item.dataset.block !== blockName(dragId))
                    return; // nur innerhalb desselben Blocks
                e.preventDefault();
                item.classList.add('is-drop-target');
            });
            item.addEventListener('dragleave', () => item.classList.remove('is-drop-target'));
            item.addEventListener('drop', (e) => {
                e.preventDefault();
                const targetId = item.dataset.mp;
                if (!dragId || dragId === targetId)
                    return;
                if (item.dataset.block !== blockName(dragId))
                    return;
                reorderWithin(dragId, targetId);
            });
        }
    }
    function toggleFavorite(id) {
        if (view.favorites.includes(id)) {
            view.favorites = view.favorites.filter((x) => x !== id);
            view.others = [...view.others, id];
        }
        else {
            view.others = view.others.filter((x) => x !== id);
            view.favorites = [...view.favorites, id];
        }
        renderNav();
        void savePrefs(ctx, view);
    }
    function move(id, dir) {
        const arr = blockArr(id);
        const i = arr.indexOf(id);
        const j = i + dir;
        if (i < 0 || j < 0 || j >= arr.length)
            return;
        [arr[i], arr[j]] = [arr[j], arr[i]];
        renderNav();
        void savePrefs(ctx, view);
    }
    function reorderWithin(srcId, targetId) {
        const arr = blockArr(srcId);
        const from = arr.indexOf(srcId);
        const to = arr.indexOf(targetId);
        if (from < 0 || to < 0)
            return;
        arr.splice(from, 1);
        arr.splice(to, 0, srcId);
        renderNav();
        void savePrefs(ctx, view);
    }
    async function activate(id) {
        const mp = byId.get(id) ?? marketplaces[0];
        activeId = mp.id;
        renderNav();
        mpEl.innerHTML = `<span class="kl-sidebar-tile">${mp.tile}</span> ${mp.label}`;
        panelEl.innerHTML = '';
        await mp.render(panelEl, ctx);
    }
    // Tenant-Name in den Sidebar-Brand laden (RLS-gefiltert). Kein UUID-Fallback.
    void (async () => {
        const { data } = await ctx.supabase
            .schema('account')
            .from('tenants')
            .select('name')
            .eq('id', ctx.session.tenantId)
            .maybeSingle();
        const tEl = document.getElementById('kl-sidebar-tenant');
        if (!tEl)
            return;
        if (data?.name) {
            tEl.textContent = data.name;
        }
        else {
            tEl.textContent = '';
            tEl.style.display = 'none';
        }
    })();
    // Logout: persistSession ist false → ein Reload verwirft die In-Memory-Session
    // und zeigt wieder den Standalone-Login.
    const logoutBtn = ctx.contentEl.querySelector('#kl-logout');
    logoutBtn?.addEventListener('click', () => {
        window.location.reload();
    });
    renderNav();
    await activate(activeId);
}
//# sourceMappingURL=shell.js.map